import { AlertTriangle } from 'lucide-react'
import { Modal } from './Modal'
import { Button } from './ui/button'

interface Props {
  title: string
  message: string
  confirmLabel?: string
  onConfirm: () => void
  onCancel: () => void
  loading?: boolean
}

export function ConfirmDialog({ title, message, confirmLabel = 'Delete', onConfirm, onCancel, loading }: Props) {
  return (
    <Modal title={title} onClose={onCancel} size="sm">
      <div className="flex gap-4 mb-8">
        <div className="h-12 w-12 rounded-full bg-error-50 flex items-center justify-center shrink-0">
          <AlertTriangle size={22} className="text-error-500" />
        </div>
        <p className="text-sm text-gray-500 leading-relaxed pt-1">{message}</p>
      </div>
      <div className="flex justify-end gap-3">
        <Button variant="secondary" size="sm" onClick={onCancel}>Cancel</Button>
        <Button variant="danger" size="sm" onClick={onConfirm} disabled={loading}>
          {loading ? 'Deleting…' : confirmLabel}
        </Button>
      </div>
    </Modal>
  )
}
